import { render, staticRenderFns } from "./weihua.vue?vue&type=template&id=39a69802"
import script from "./weihua.vue?vue&type=script&lang=js"
export * from "./weihua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports